import { render } from "./ObjectTab.vue?vue&type=template&id=35fcca82"
import script from "./ObjectTab.vue?vue&type=script&lang=js"
export * from "./ObjectTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__